export default function filterValidPaymentOptions({
	numberOfDaysBetweenTwoDates,
	numberOfMonthsBetweenTwoDates,
	availablePaymentOptions,
}) {
	const validOptions = [];

	// Always allow SINGLE if available
	if (availablePaymentOptions.includes('SINGLE')) {
		validOptions.push('SINGLE');
	}

	// For policies > 31 days, check other options
	if (numberOfDaysBetweenTwoDates > 31) {
		// Monthly options (need at least 1 month)
		if (numberOfMonthsBetweenTwoDates >= 1) {
			if (availablePaymentOptions.includes('MONTHLY')) {
				validOptions.push('MONTHLY');
			}
			if (availablePaymentOptions.includes('MONTHLY_ONE_UP_FRONT')) {
				validOptions.push('MONTHLY_ONE_UP_FRONT');
			}
			if (availablePaymentOptions.includes('MONTHLY_TWO_UP_FRONT')) {
				validOptions.push('MONTHLY_TWO_UP_FRONT');
			}
		}

		// Quarterly (needs at least 3 months)
		if (numberOfMonthsBetweenTwoDates >= 3 && availablePaymentOptions.includes('QUARTERLY')) {
			validOptions.push('QUARTERLY');
		}

		// Annual options (need at least 365 days AND 6/12 months respectively)
		if (numberOfDaysBetweenTwoDates >= 365) {
			if (numberOfMonthsBetweenTwoDates >= 6 && availablePaymentOptions.includes('SEMI_ANNUAL')) {
				validOptions.push('SEMI_ANNUAL');
			}
			if (numberOfMonthsBetweenTwoDates >= 12 && availablePaymentOptions.includes('ANNUAL')) {
				validOptions.push('ANNUAL');
			}
		}
	}

	return validOptions;
}
